import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getAquaaAccountsData, getAquaaAgentsData, getAquaaAWSData, getAquaaChannelsData, getAquaaLanguagesData, getAquaaLocationsData, getAquaaValidFromData, getEvaluationFormData, saveEvaluationData } from '../../actions/Applications/aquaa.action';
import Filter_Icon from './../../assets/images/Filter_Icon.png';
import { OnboardSelect } from '../../components/Onboard/OnboardComponents/Dropdown/Select';
import DatePickerHandle from '../../components/Onboard/OnboardComponents/KeyboardDatePicker';
import './Aquaa.css'
import { useHistory } from 'react-router-dom';
// import { Link } from 'react-router-dom';
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb';


const Aquaa = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const aquaaAccounts = useSelector((state) => state.aquaaReducer.aquaaAccounts);
  const aquaaAgents = useSelector((state) => state.aquaaReducer.aquaaAgents);
  const aquaaChannels = useSelector((state) => state.aquaaReducer.aquaaChannels);
  const aquaaLanguages = useSelector((state) => state.aquaaReducer.aquaaLanguages);
  const aquaaLocations = useSelector((state) => state.aquaaReducer.aquaaLocations);
  const aquaaValidFrom = useSelector((state) => state.aquaaReducer.aquaaValidFrom);
  const aquaaAWS = useSelector((state) => state.aquaaReducer.aquaaAWS);
  const evaluationData = useSelector((state) => state.aquaaReducer.evaluationData);
  
  const [isRefreshClicked, setIsRefreshedClicked] = useState(false); 
  const [selectedRole, setSelectedRole] = useState();
  const [selectedAccount, setSelectedAccount] = useState();
  const [selectedChannel, setSelectedChannel] = useState();
  const [selectedLanguage, setSelectedLanguage] = useState();
  const [selectedLocation, setSelectedLocation] = useState();
  const [loadClicked, setLoadCliked] = useState(false)
  const [isEvaluationFetched, setIsEvaluationFetched] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' }); // Added sorting state

  useEffect(()=>{
setLoadCliked(false)
  },[])

  const addValueToAccount = (name, value) => {
    if (value !== 'Select') {
        const selectedAccountData = aquaaAccounts.find(account => account.accountName === value);
        
        if (selectedAccountData) {
            const newFormData = { 
                ...selectedAccount,  
                ...selectedAccountData,  
            };
            setSelectedAccount(newFormData);
        }
    }
};

  console.log('selectedAccount',selectedAccount)
  useEffect(()=> {
    dispatch(getAquaaAccountsData());
    dispatch(getAquaaValidFromData());
  }, [dispatch]);


  useEffect(() => {
    if (selectedAccount) {
      dispatch(getAquaaLocationsData(selectedAccount.accountID));

    }
  }, [dispatch, selectedAccount]); 

  useEffect(() => {
    if (selectedAccount && selectedLocation) {
      dispatch(getAquaaChannelsData(selectedAccount.accountID, selectedLocation.location));
    }
  }, [dispatch, selectedAccount, selectedLocation]);  


  const updateSelectedChannelWithObject = (selectedValue, channels) => {
    const selectedObject = channels.find(channel => channel.contactTypeForm === selectedValue);
  
    if (selectedObject) {
      setSelectedChannel(selectedObject); 
    } else {
      console.error('Selected value does not match any available channels.');
    }
  };

  const updateSelectedLocationWithObject = (selectedValue, location) => {
    const selectedObject = location.find(location => location.location === selectedValue);
  
    if (selectedObject) {
      setSelectedLocation(selectedObject); 
    } else {
      console.error('Selected value does not match any available location.');
    }
  };


  console.log('selectedChannel',selectedChannel)

  useEffect(() => {
    if (selectedAccount && selectedRole && selectedChannel && selectedLocation) {
      dispatch(getAquaaLanguagesData(selectedAccount.accountID, selectedRole, selectedChannel.channel, selectedLocation.location));
    }
  }, [dispatch, selectedAccount, selectedRole, selectedChannel, selectedLocation]);  

  useEffect(() => {
    if (selectedAccount && selectedLocation && selectedChannel) {
      dispatch(getAquaaAgentsData(selectedAccount.accountID,selectedLocation.location,selectedChannel.contactTypeID));

    }
  }, [dispatch, selectedAccount, selectedLocation, selectedChannel]);  

  const columns = aquaaAWS && aquaaAWS.length > 0 ? Object.keys(aquaaAWS[0]) : [];

  // Sorting function to handle sorting of columns
  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return aquaaAWS;
    
    const sortedArray = [...aquaaAWS].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
    return sortedArray;
  }, [aquaaAWS, sortConfig]); // Re-sort when `sortConfig` changes

  // Handle header click to toggle sorting order
  const handleSort = (column) => {
    setSortConfig((prevState) => {
      if (prevState.key === column) {
        // If same column is clicked again, toggle direction
        return { key: column, direction: prevState.direction === 'asc' ? 'desc' : 'asc' };
      } else {
        // Otherwise, sort by the new column and set to ascending
        return { key: column, direction: 'asc' };
      }
    });
  };

  function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [month, day, year].join('/');
  }

  const[saveContactId,setSaveContactId] = useState()

  const contactIdHandler = (row) => {
    if (row.contactid && !isEvaluationFetched) {
      dispatch({ type: 'EVALUATION_FORM_DATA', payload: [] });
      setIsEvaluationFetched(true); // Mark that the data has been fetched
      setSaveContactId(row.contactid)
      dispatch(getEvaluationFormData(row.contactid, selectedChannel.contactTypeID, selectedLocation.countryID)); // Fetch the evaluation data for this contact

    }
  };

  useEffect(()=>{
    if (evaluationData && Array.isArray(evaluationData) && evaluationData.length > 0 &&
     saveContactId === evaluationData?.[0]?.AccountDetails?.[0]?.contactid) {
      dispatch(saveEvaluationData(evaluationData))
      history.push('/evaluationform')
    }
  },[evaluationData,dispatch,history,saveContactId])

  // // UseEffect to handle navigation after data is fetched
  // useEffect(() => {
  //   if (evaluationData && Array.isArray(evaluationData) && evaluationData.length > 0 && isEvaluationFetched) {
  //     history.push({
  //       pathname: '/evaluationform',
  //       state: { evaluationData }, // Pass the evaluation data to the next page
  //     });
  //     setIsEvaluationFetched(false); // Reset flag after navigation
  //   } else {
  //     console.log("No valid evaluation data found.");
  //   }
  // }, [evaluationData, isEvaluationFetched, history]);
 

const [selectedDate, setSelectedDate] = useState(() => {
  const fromDateString = aquaaValidFrom?.[0]?.fromDate;
  return {
    From: fromDateString ? formatDate(new Date(fromDateString)) : null,
    To: formatDate(new Date())
  };
});
useEffect(() => {
  const fromDateString = aquaaValidFrom?.[0]?.fromDate;
  if (fromDateString) {
    setSelectedDate(prev => ({
      ...prev,
      From: formatDate(new Date(fromDateString))
    }));
  }
}, [aquaaValidFrom]);

const FromDateHandler = (date) => {
  setSelectedDate({...selectedDate, From: (date === null || date === undefined) ? null : formatDate(date)});
  
}

const ToDateHandler = (date) => {
  setSelectedDate({...selectedDate, To: (date === null || date === undefined) ? null : formatDate(date)});
  
}
  

  return (
    <div>
          <AdminBreadcrumb value1={()=>history.push('/applications')} label1='Applications' isActive2={true} value2={()=>history.push('/aquaaapplications')} label2='AQuAA' isActive3={false} label3='AQuAA - ASD'/>

      <section className='App_Layout'>
       <main className='Title_bar'> <div className='Applications_Title'> AQuAA - ASD </div>
       <div className='btn_adduser' onClick={()=>{history.push('/savedevaluations')}}>Manage</div></main>
      </section>
      <section className='Filter_aquaa'>
        <main className='aquaa_filter_img'>
          <img src={Filter_Icon} alt='' style={{ padding: '20px', paddingTop: '70px', paddingLeft: '30px' }} />
        </main>
        <div className='aquaaFilterAlignment'>
          <main className='Aquaa_dropdown'>
            <label HtmlFor='country'>Account</label>
            <OnboardSelect data={aquaaAccounts} name='accountName' value='accountName' id='RoleId' marginTop='10px'
              editValue='' addValueToQueue= { addValueToAccount } refresh={isRefreshClicked} />
          </main>
          <main className='Aquaa_dropdown'>
            <label HtmlFor='country'>Location</label>
            <OnboardSelect data={aquaaLocations} name='Region' value='location' id='Id' marginTop='10px'
              editValue='' addValueToQueue={(name, selectedValue) => {
          updateSelectedLocationWithObject(selectedValue, aquaaLocations);
          setIsRefreshedClicked(false); 
        }} refresh={isRefreshClicked} />
          </main>
          
          <main className='Aquaa_dropdown'>
            <label HtmlFor='country'>Evaluation Form</label>
            <OnboardSelect data={aquaaChannels} name='evaluationForm' value='contactTypeForm' id='Id' marginTop='10px'
              editValue='' addValueToQueue={(name, selectedValue) => {
          updateSelectedChannelWithObject(selectedValue, aquaaChannels);
          setIsRefreshedClicked(false); 
        }} refresh={isRefreshClicked} />
          </main>
          <main className='Aquaa_dropdown'>
            <label HtmlFor='username'>Agent</label>
            <OnboardSelect data={aquaaAgents} name='Role' value='agent' id='RoleId' marginTop='10px'
              editValue='' addValueToQueue={(name, value) => { setSelectedRole(value); setIsRefreshedClicked(false) }} refresh={isRefreshClicked} />
          </main>
          <main className='Aquaa_dropdown'>
            <label HtmlFor='country'>Language</label>
            <OnboardSelect data={aquaaLanguages} name='Servicedesk' value='language' id='SiteId' marginTop='10px'
              editValue='' addValueToQueue={(name, value) => { setSelectedLanguage(value); setIsRefreshedClicked(false) }} refresh={isRefreshClicked} />
          </main>
          
          <main className='Aquaa_dropdown'>
            <DatePickerHandle  label='From' id='label'  value={(selectedDate?.From === undefined || selectedDate?.From === null) ? null : selectedDate?.From}
            onChange={(date) => FromDateHandler(date)}/>
          </main>
          <main className='Aquaa_dropdown'>
            <DatePickerHandle  label='To' id='label' value={(selectedDate?.To === undefined || selectedDate?.To === null) ? null : selectedDate?.To}
            onChange={(date) => ToDateHandler(date)}/>
          </main>
          <button className='btn_adduser' onClick={() => {
            dispatch(getAquaaAWSData(selectedAccount.accountID, selectedRole, selectedChannel.channel, selectedLanguage, selectedLocation.location, selectedDate.From, selectedDate.To));
            setLoadCliked(true)
          }}>LOAD</button>
        </div>
      </section>

      <section style={{ marginTop: '20px' }}>
        <div className="aquaa-table-container">
      {!loadClicked ? 
        <section><div className='noData-para' style={{ marginTop: 0 }}>
                <div style={{ marginTop: 30 }}>
      Please select all the filters to load the data  </div></div></section>
      : <table className="aquaa-table">
            <thead>
              <tr>
                {columns.map((col, index) => (
                  <th key={index} onClick={() => col === 'talktime' && handleSort(col)}>
                    {col}
                    {col === 'talktime' && sortConfig.key === col ? (
                      sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
                    ) : null}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedData && sortedData.length > 0 ? (
                sortedData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {columns.map((col, colIndex) => {
                      const cellData = row[col];

                      if (col === 'Row_date') {
                        return <td key={colIndex}>{formatDate(cellData)}</td>;
                      }

                      return <td key={colIndex}  style={(col === 'contactid') ? {cursor:'pointer',color:'#004aac'} : null}>
                       {col === 'contactid' ? <div onClick={()=>{contactIdHandler(row)}}> {cellData} </div> : cellData}
                        </td>;
                    })}
                  </tr>
                ))
              ) : (
                <tr><td colSpan={columns.length}>
                <section>
              <div className='noData-para' style={{ marginTop: 0 }}>
                <div style={{ marginTop: 30 }}>
                No data available, please try different filters or contact the admin
                </div></div></section></td></tr>
              )}
            </tbody>
          </table>}
        </div>
      </section>
    </div>
  );
}

export default Aquaa;
